import Drawer from "@mui/material/Drawer";
import { runInAction } from "mobx";
import { borderWidths, sizes } from "et3-ui-library";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCoreUIStore from "../../stores/core/core-ui-store";
import SideBarContent from "./SideBarContent";

const SideBar = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { unitX } = theme;
  const { shouldShowSideBar, isMobileNav, isMobileNavOpen } = getCoreUIStore();
  const closeMobileNav = () => runInAction(() => isMobileNavOpen.set(false));

  if (shouldShowSideBar.get()) {
    return (
      <Drawer
        variant="permanent"
        sx={{
          width: 300 * unitX,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            position: "relative",
            width: 300 * unitX,
            height: "100%",
            boxSizing: "border-box",
            overflowX: "hidden",
            overflowY: "auto",
            borderRight: `${borderWidths.thin}px solid`,
            borderColor: "divider"
          }
        }}
      >
        <SideBarContent onNavigate={closeMobileNav} />
      </Drawer>
    );
  }

  if (isMobileNav.get()) {
    return (
      <Drawer
        variant="temporary"
        open={isMobileNavOpen.get()}
        onClose={closeMobileNav}
        ModalProps={{ keepMounted: true }}
        sx={{ "& .MuiDrawer-paper": { width: sizes.drawerWidth } }}
      >
        <SideBarContent onNavigate={closeMobileNav} />
      </Drawer>
    );
  }

  return null;
});
export default SideBar;
